import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../compopnents/button";
import Modal from "../../compopnents/modal";
import { FormInput } from "../../wrappers/formInput";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { DropDownInput } from "../../wrappers/selectInput";
import DatepickerDefault from "../../compopnents/daterangePicker";
import { getMilliSec, getMilliSecUTC } from "../../utils/ellowutils";
import * as CONSTANTS from '../../utils/CONSTANTS'

export type TimeSheetFilterFormFields = {
  reportingManager: string;
  duration: any;
  status: any;
  projectName: string;
};

interface Props {
  ClickHandler?: any;
  onClose?: any;
  defaultValues?: any;
  jobId?: any;
  allocatedTo?: any;
}

const validationSchema = Yup.object({});

const TimeSheetFilter: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues,
  allocatedTo,
}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<TimeSheetFilterFormFields>(formOptions);

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues)
      if(defaultValues.status === "Approved"){
        setValue('status',{ name: "Approved", id: 3 })
      }
      if(defaultValues.status === "Rejected"){
        setValue('status',{ name: "Rejected", id: 4 })
      }
      if(defaultValues.status === "Pending"){
        setValue('status',{ name: "Pending", id: 2 })
      }
    }    
  }, [defaultValues]);

  const onSubmit = (data: any) => {
    ClickHandler(data)
  }

  const handleChange = (e: any, name: string) => { 
    if (name === "duration") {
      let dateWithin = {
        startDateFrom: getMilliSecUTC(e.target.value.start),
        startDateTo: getMilliSecUTC(e.target.value.start),
        endDateFrom: getMilliSecUTC(e.target.value.end),
        endDateTo: getMilliSecUTC(e.target.value.end)
      };
      setValue("duration",  dateWithin);
    }
  }

  return (
    <Modal title={" "} onClose={onClose} size="medium">
      <form>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Project Name</label>
            <FormInput<TimeSheetFilterFormFields>
              name="projectName"
              placeholder="Project Name"
              register={register}
              errors={errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Reporting Manager</label>
            <FormInput<TimeSheetFilterFormFields>
              name="reportingManager"
              placeholder="Reporting Manager"
              register={register}
              errors={errors}
            />
          </div>
        </div>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Status</label>
            <DropDownInput<TimeSheetFilterFormFields>
              name="status"
              data={CONSTANTS.timeSheetstatus}
              register={register}
              errors={errors}
              control={control}
              dataItemKey="id"
              textField="name"
            />
          </div>
          <div className="form-group no-label-datepicker">
              <label className="lablel">Contract Duration</label>
              <DatepickerDefault
                onChange={(e: any) => handleChange(e, "duration")}
              />
          </div>
        </div>
        <div className="popupAction">
          <Button
            onClick={onClose}
            type="submit"
            variant="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            type="submit"
            variant="primary"
            size="small"
          >
            Apply Filters
          </Button>
        </div>
      </form>
    </Modal>
  );
};
export default TimeSheetFilter;
